// extracted by mini-css-extract-plugin
export var aircallIframe = "_cr-3";
export var fabContainer = "_cr-5";
export var fabRinging = "_cr-6";
export var loadingOverlay = "_cr-4";
export var pulse = "_cr-7";
export var widgetContent = "_cr-2";
export var widgetPanel = "_cr-0";
export var widgetPanelExpanded = "_cr-1";